export default __webpack_public_path__ + "static/media/updapt's-satish-ramchandani.7a3f5c41.jpg";